// extracted by mini-css-extract-plugin
export var accordion = "_bo-0";
export var chevron = "_bo-3";
export var closed = "_bo-2";
export var content = "_bo-4";
export var open = "_bo-1";
export var rotate = "_bo-5";